import { render, staticRenderFns } from "./PinOnImage.vue?vue&type=template&id=23b2c865&scoped=true"
import script from "./PinOnImage.vue?vue&type=script&lang=ts"
export * from "./PinOnImage.vue?vue&type=script&lang=ts"
import style0 from "./PinOnImage.vue?vue&type=style&index=0&id=23b2c865&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b2c865",
  null
  
)

export default component.exports